import React, { useEffect, useState } from "react";
import apiClient from "../BaseUrl/apiClient.js";
import TokenService from "../service/TokenService";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles"; // Import useTheme from MUI

function DisplayAdminMsg() {
  const [adminMsg, setAdminMsg] = useState("");
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const theme = useTheme(); // Correct useTheme import
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if the viewport is mobile

  const getdata = async () => {
    apiClient
      .post("/getdashboarddata", { uname })
      .then((response) => {
        setAdminMsg(response.data[0].displayMassge);
      })
      .catch((error) => {
        alert(error);
      });
  };

  useEffect(() => {
    getdata();
  }, [getdata]);

  return <div>{adminMsg && !isMobile && adminMsg}</div>;
}

export default DisplayAdminMsg;
